/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ObjectAttributeCondition, { ObjectAttributeSource } from 'cio/app-models/conditions/object-attribute';
import { OperatorGroup } from 'cio/components/condition-editor/attribute';
import { inject as service } from '@ember/service';
import { action, computed } from '@ember/object';
import RelationshipCondition from 'cio/app-models/conditions/relationship';
import ObjectTypesService from 'cio/services/object-types';
import FeaturesService from 'ember-feature-flags/services/features';

interface Args {
  filters: ObjectAttributeCondition[];
  filter: ObjectAttributeCondition;
  index: number;
  filterOperator: 'and' | 'or';
  depth: number;
  condition: RelationshipCondition;
  onRemove: (filter: ObjectAttributeCondition) => unknown;
  disabled: boolean;
}

export default class CioConditionEditorRelationshipDataFilterAttribute extends Component<Args> {
  @service objectTypes!: ObjectTypesService;
  @service features!: FeaturesService;

  readonly isRelationshipAttributesEnabled = this.features.isEnabled('campaign_trigger_ui_new');

  get attributeSourceOptions() {
    if (!this.isRelationshipAttributesEnabled) {
      return null;
    }

    return [
      { value: ObjectAttributeSource.ObjectAttribute, label: `${this.objectType?.singularName ?? 'Object'} attribute` },
      { value: ObjectAttributeSource.RelationshipAttribute, label: 'Relationship attribute' },
    ];
  }

  get nextDepthClassModifier() {
    return `${(this.args.depth + 1) % 2 === 0 ? 'even' : 'odd'}`;
  }

  @computed('args.filter.editableCondition.objectAttributeSource')
  get objectPrefix() {
    if (this.args.filter.editableCondition.objectAttributeSource === ObjectAttributeSource.ObjectAttribute) {
      return `${this.objectType?.singularName ?? 'Object'} attribute`;
    }

    return 'Relationship attribute';
  }

  @computed('args.filter.editableCondition.objectAttributeSource', 'objectType.{sentAttributes,sentRelAttributes}')
  get attributeNames() {
    if (this.args.filter.editableCondition.objectAttributeSource === ObjectAttributeSource.ObjectAttribute) {
      return this.objectType?.sentAttributes ?? [];
    }

    return this.objectType?.sentRelAttributes ?? [];
  }

  get operatorGroups() {
    return [
      OperatorGroup.StringOrNumber,
      OperatorGroup.String,
      OperatorGroup.JsonArray,
      OperatorGroup.JsonObject,
      OperatorGroup.UnixTimestamp,
    ];
  }

  get objectType() {
    let objectTypes = this.objectTypes.enabledObjectTypes;
    let objectType = this.args.condition.typeId ?? objectTypes?.[0]?.id;
    return objectTypes.find(({ id }) => id === objectType);
  }

  @action
  duplicateFilter(filter: ObjectAttributeCondition) {
    let duplicate = filter.duplicate();
    this.args.condition.set('filters', [...this.args.condition.filters, duplicate]);
  }
}
